module.exports = __webpack_public_path__ + "img/ASAN_05.f878a790.png";